export default __webpack_public_path__ + "static/media/xliteplus.65147516.svg";